<template>
  <div class="row">
    <div class="col-sm-12">
      <div
        class="d-flex flex-wrap justify-content-center align-items-center px-3 py-2 border-bottom bg-white gap-3"
      >
        <h5 class="mb-0 h6 fw-bold">Pending Actions</h5>
        <IconRefresh
          size="16"
          class="text-success ms-2"
          style="cursor: pointer"
          @click="handlePendingActionsRefresh"
        />
        <IconMessagePlus
          size="16"
          class="text-primary ms-2"
          style="cursor: pointer"
          @click="createModal = true"
        />
      </div>
    </div>
    <div class="col-sm-12">
      <ListView ref="pendingActionsList" :acctUid="acctUid" />
    </div>
    <CreatePendingActionModal
      v-if="acctUid"
      v-model="createModal"
      :acctUid="acctUid"
      @pendingActionCreated="fetchPendingActions(true)"
    />
  </div>
</template>
<script>
import { IconRefresh, IconMessagePlus } from "@tabler/icons-vue";
import ListView from "@/components/PendingActions/ListView.vue";
import CreatePendingActionModal from "@/components/PendingActions/CreatePendingActionModal.vue";

export default {
  name: "PendingActionsIndexView",
  props: {
    acctUid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      createModal: false,
    };
  },
  components: {
    ListView,
    CreatePendingActionModal,
    IconRefresh,
    IconMessagePlus,
  },
  methods: {
    handlePendingActionsRefresh() {
      this.$refs.pendingActionsList.fetchPendingActions(true);
    },
  },
};
</script>
